import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    What is an MVP (Minimum Viable Product), and how can it benefit my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>An MVP is a minimally viable product or service designed to test critical assumptions and gather feedback from potential customers. The goal of an MVP is to minimize waste and risk while maximizing learning and progress. An MVP can be a valuable tool for businesses looking to bring new products or services to market quickly and efficiently.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are the key considerations when developing an MVP?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>When developing an MVP, it's important to focus on the key features and capabilities necessary to test your assumptions and gather valuable feedback. It's also a good idea to keep the MVP as simple and streamlined as possible while providing a functional and valuable user experience. Other considerations may include the target audience, the budget and resources available, and the timeline for development and testing.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    Can TekRevol help me develop an MVP for my business?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Yes, TekRevol has a team of experienced professionals with expertise in MVP development. We have a record of success in helping businesses to develop and test MVPs, gather valuable feedback, and iterate and improve their products or services. Our team has the skills and knowledge to help you create a custom MVP that meets your specific needs and goals. Whether you're looking to bring a new product or service to market or to optimize your existing business model, we can help you create an MVP that works for you.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;